/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_DescInputs */



/**
* | output |
* | --- |
* | "Customize how event metrics are calculated and displayed throughout the editor." |
*
* @param {Options_Metrics_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_desc = /** @type {((inputs?: Options_Metrics_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
	return /** @type {LocalizedString} */ ("Customize how event metrics are calculated and displayed throughout the editor.")
});